import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Grid, TextField } from '@material-ui/core';
import { useStyles } from './OTP.style';
import { isNumeric } from 'validator';

const OTP: React.FC<any> = ({ onDataChange, disabled = false }: any) => {
  const classes = useStyles();

  const [value, setValue] = useState({
    0: '',
    1: '',
    2: '',
    3: '',
    4: '',
    5: '',
  });
  const inputRef0 = useRef<any>(null);
  const inputRef1 = useRef<any>(null);
  const inputRef2 = useRef<any>(null);
  const inputRef3 = useRef<any>(null);
  const inputRef4 = useRef<any>(null);
  const inputRef5 = useRef<any>(null);

  useEffect(() => {
    onDataChange(
      Object.keys(value)
        .map((index) => (value as any)[index])
        .join('')
    );
  }, [value, onDataChange]);

  const navigateCursorForward = useCallback((index: number) => {
    switch (index) {
      case 0:
        inputRef1.current.focus();
        break;

      case 1:
        inputRef2.current.focus();
        break;

      case 2:
        inputRef3.current.focus();
        break;

      case 3:
        inputRef4.current.focus();
        break;

      case 4:
        inputRef5.current.focus();
        break;
    }
  }, []);

  const navigateCursorBackward = useCallback((index: number) => {
    switch (index) {
      case 1:
        inputRef0.current.focus();
        break;

      case 2:
        inputRef1.current.focus();
        break;

      case 3:
        inputRef2.current.focus();
        break;

      case 4:
        inputRef3.current.focus();
        break;

      case 5:
        inputRef4.current.focus();
        break;
    }
  }, []);

  const handleUpdate = useCallback((value: string, index: number) => {
    if ((isNumeric(value) || value === '') && index < 6) {
      setValue((prev) => {
        const newIndex = index;
        return {
          ...prev,
          [newIndex]: value,
        };
      });
    }
  }, []);

  const onHandleKeyDown = useCallback(
    (index: number) => (event: React.KeyboardEvent<HTMLDivElement>) => {
      const { key } = event;
      const newValue = (value as any)[index];

      if (key === 'Backspace') {
        const newIndex = newValue ? index : index - 1;
        handleUpdate('', newIndex);
        !newValue && navigateCursorBackward(index);
      } else if (isNumeric(key)) {
        handleUpdate(key, index);
        navigateCursorForward(index);
      }
    },
    [handleUpdate, navigateCursorForward, navigateCursorBackward, value]
  );

  const onHandlePaste = useCallback(
    (index: number) => (e: any) => {
      const clipboard = e.clipboardData || (window as any)?.clipboardData;
      const text = clipboard.getData('Text');

      if (isNumeric(text)) {
        let newIndex = index;
        text.split('').forEach((item: string) => {
          handleUpdate(item, newIndex);
          navigateCursorForward(newIndex);
          newIndex++;
        });
      }
    },
    [handleUpdate, navigateCursorForward]
  );

  const renderTextField = useCallback(
    ({ id, index, ref, value, disabled }) => (
      <Grid item xs={2}>
        <TextField
          type="tel"
          disabled={disabled}
          autoFocus={!index}
          inputRef={ref}
          id={id}
          hiddenLabel
          onKeyDown={onHandleKeyDown(index)}
          onPaste={onHandlePaste(index)}
          value={value}
          autoComplete="one-time-code"
          inputProps={{
            maxLength: '1',
            pattern: '[0-9]*',
            className: classes.inputStyle,
          }}
          InputProps={{ classes: { root: classes.textField__root } }}
        />
      </Grid>
    ),
    [classes, onHandleKeyDown, onHandlePaste]
  );

  return (
    <Grid container spacing={1}>
      {renderTextField({
        index: 0,
        id: 'number0',
        ref: inputRef0,
        value: value['0'],
        disabled,
      })}
      {renderTextField({
        index: 1,
        id: 'number1',
        ref: inputRef1,
        value: value['1'],
        disabled,
      })}
      {renderTextField({
        index: 2,
        id: 'number2',
        ref: inputRef2,
        value: value['2'],
        disabled,
      })}
      {renderTextField({
        index: 3,
        id: 'number3',
        ref: inputRef3,
        value: value['3'],
        disabled,
      })}
      {renderTextField({
        index: 4,
        id: 'number4',
        ref: inputRef4,
        value: value['4'],
        disabled,
      })}
      {renderTextField({
        index: 5,
        id: 'number5',
        ref: inputRef5,
        value: value['5'],
        disabled,
      })}
    </Grid>
  );
};

export default OTP;
